/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';

import ReactSelect from 'react-select';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { models } from './constants';

import { Container, Feedback, Label } from './styles';

export default function Select({
  options,
  placeholder,
  model,
  label,
  onChange,
  minWidth,
  feedbackMessage: externalFeedbackMessage,
  required,
  isClearable,
  menuPlacement,
  isLoading,
  defaultValue,
  value,
  readonly,
  isMulti,
  inline,
  zIndex,
  textAlign,
  id,
  cy,
}) {
  const [feedbackMessage, setFeedbackMessage] = useState(externalFeedbackMessage);
  const tempTheme = useSelector((state) => state.theme);
  const { t } = useTranslation();

  function handleChange(event) {
    const shouldShowRequiredFieldMessage = (event?.value === '' && required);

    onChange(event);

    if (shouldShowRequiredFieldMessage) {
      setFeedbackMessage(t('feedback.requiredField'));
      return;
    }
    setFeedbackMessage(null);
  }

  useEffect(() => {
    setFeedbackMessage(externalFeedbackMessage);
  }, [externalFeedbackMessage]);

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      ...(state.isDisabled ? {
        backgroundColor: tempTheme.colors.input.w200,
        borderColor: tempTheme.colors.secondary.w100,
        boxShadow: `0 0 0 2px ${tempTheme.colors.secondary.w100}`,
        cursor: 'not-allowed',
        filter: 'none',
        opacity: 1,
      } : {}),
    }),
    singleValue: (base, state) => ({
      ...base,
      ...(state.isDisabled ? {
        color: tempTheme.colors.text.w000,
      } : {}),
    }),
    placeholder: (base, state) => ({
      ...base,
      ...(state.isDisabled ? {
        color: tempTheme.colors.text.w100,
      } : {}),
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      ...(state.isDisabled ? {
        color: tempTheme.colors.secondary.w050,
      } : {}),
    }),
    indicatorSeparator: (base, state) => ({
      ...base,
      ...(state.isDisabled ? {
        backgroundColor: tempTheme.colors.secondary.w100,
      } : {}),
    }),
  };

  if (!defaultValue && model === models.dark) return null;

  return (
    <Container model={model} inline={inline} textAlign={textAlign} data-cy={cy} zIndex={zIndex} minWidth={minWidth}>
      {label && <Label>{label}</Label>}
      <ReactSelect
        id={id}
        value={value}
        isLoading={isLoading}
        className="react-select"
        classNamePrefix="react-select"
        blurInputOnSelect
        placeholder={placeholder}
        defaultValue={defaultValue}
        menuPlacement={menuPlacement}
        onChange={(event) => handleChange(event)}
        options={options}
        isMulti={isMulti}
        isDisabled={readonly}
        isSearchable={!readonly}
        isClearable={isClearable}
        menuIsOpen={readonly ? false : undefined}
        styles={selectStyles}
        theme={(theme) => ({
          ...theme,
          colors: {
            primary: tempTheme.colors.primary.w100,
            primary75: tempTheme.colors.primary.w200,
            primary50: tempTheme.colors.primary.w200,
            primary25: tempTheme.colors.primary.w200,
            neutral50: '#ffffffd3',
          },
        })}
      />
      <Feedback>{feedbackMessage}</Feedback>
    </Container>
  );
}

Select.defaultProps = {
  onChange: () => { /* */ },
  model: models.light,
  options: [],
  placeholder: '',
  required: false,
  label: '',
  menuPlacement: 'auto',
  isLoading: false,
  defaultValue: null,
  isMulti: false,
  textAlign: 'center',
};

export { models };
